import {
    IonButton,
    IonCard,
    IonCardContent,
    IonContent,
    IonHeader,
    IonInput,
    IonLoading,
    IonPage,
    IonText,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import {useEffect, useState} from "react";
import {Link, useHistory} from 'react-router-dom'
import createAxiosInstance from '../../services/AxiosInstance';

import { useToast } from "../../utils/useToasts";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {initializeSession, setToken} from "../../store/slices/authSlice";
import './AuthPages.css';

const Login: React.FC = () => {
    const history = useHistory();
    const [busy, setBusy] = useState<boolean>(false);
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("")
    const axios = createAxiosInstance();
    const showToasts = useToast();
    const dispatch = useAppDispatch();
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/');
        }
    }, [history, isAuthenticated]);

    async function login() {
        try {
            if (!identifier.trim() || !password.trim()) {
                showToasts('Vul je gebruikersnaam/e-mail en wachtwoord in', 'danger')
                return;
            }
            setBusy(true);
            await performLogin(identifier, password);
        } catch (e) {
            console.error(e)
        } finally {
            setBusy(false);
        }
    }

    const performLogin = async (rawIdentifier: string, password: string) => {
        const loginIdentifier = rawIdentifier.trim();
        const loginWithEmail = loginIdentifier.includes('@');
        const loginBody = {
            ...(loginWithEmail ? { email: loginIdentifier } : { username: loginIdentifier }),
            password: password
        }
        try {
            const res = await axios.post(`/auth/login`, loginBody);
            if (res.status === 200) {
                showToasts('Succesvol ingelogd!', 'success')
                dispatch(setToken(res.data.token));
                dispatch(initializeSession());
                history.push('/welkom')
            }
        } catch (err) {
            console.error(err);
            showToasts('Inlog onsuccesvol', 'danger')
            throw err;
        }
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Login</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonLoading message="Please wait.." duration={0} isOpen={busy}/>
            <IonContent className="ion-padding auth-page">
                <div className="auth-wrapper">
                    <IonCard className="auth-card">
                        <IonCardContent>
                            <div className="auth-heading">
                                <h1>Welkom terug</h1>
                                <IonText color="medium">
                                    <p>Log in met je gebruikersnaam of e-mailadres.</p>
                                </IonText>
                            </div>
                            <form
                                className="auth-form"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    if (!busy) {
                                        login();
                                    }
                                }}
                            >
                                <IonInput
                                    fill="outline"
                                    label="Gebruikersnaam of e-mail"
                                    labelPlacement="stacked"
                                    placeholder="naam of naam@voorbeeld.nl"
                                    value={identifier}
                                    autocomplete="email"
                                    onIonInput={(e) => setIdentifier(e.detail.value ?? "")}
                                />
                                <IonInput
                                    type="password"
                                    fill="outline"
                                    label="Wachtwoord"
                                    labelPlacement="stacked"
                                    placeholder="Je wachtwoord"
                                    value={password}
                                    autocomplete="current-password"
                                    onIonInput={(e) => setPassword(e.detail.value ?? "")}
                                />
                                <IonButton expand="block" type="submit" disabled={busy || !identifier.trim() || !password.trim()}>
                                    Login
                                </IonButton>
                            </form>
                            <div className="auth-links">
                                <p>Nog geen account? <Link to="/register">Registreer</Link></p>
                                <p><Link to="/request-password-reset">Wachtwoord vergeten?</Link></p>
                            </div>
                        </IonCardContent>
                    </IonCard>
                </div>
            </IonContent>
        </IonPage>
    );
}

export default Login;
